import { post } from 'services/http';

const createRelationship = body => {
  return post(`/knowledge-graph/relationships`, JSON.stringify(body), { addKgId: true });
};

export default { createRelationship };
